<template>
    <el-dialog style="padding: 0 20px 20px 20px !important;" width="800px" :title="title" :visible.sync="visible" :before-close="handleClose" top="5vh">
        <slot></slot>
    </el-dialog>
</template>

<script>
export default {
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ""
        },
        activeName: {
            type: String,
            default: ""
        }
    },
    methods: {
        // 关闭弹窗
        handleClose(isshow = false) {
            this.$emit("close-callback", isshow);
        }
    }
};
</script>

<style type="text/scss" lang="scss" scoped>
/deep/ .el-card__header {
    padding: 14px 20px !important;
}
/deep/ .el-tabs__content {
    overflow: visible !important;
}
/deep/ .el-card {
    overflow: visible !important;
}
/deep/ .el-dialog__body {
    padding: 0px 20px 20px 20px !important;
}
</style>
